module.exports = __webpack_public_path__ + "front/img/contentbg.13c6502c.jpg";